import styled from '@emotion/styled';
import breakpoints from '../../theme/material/breakpoints';

export const Content = styled('div')({
  [breakpoints.up('md')]: {
    [breakpoints.down(768.05)]: {
      marginTop: 20,
      padding: '0 10px',
    },
    [breakpoints.down(479.05)]: {
      marginTop: 20,
    },
  },
  [breakpoints.down(640.05)]: {
    padding: '0 10px',
  },
});

export const Aside = styled('div')({
  [breakpoints.up(769)]: {
    width: '100%',
  },
});

export const PrimaryContent = styled('div')({
  [breakpoints.up(480)]: {
    minHeight: 175,
  },
  [breakpoints.up(769)]: {
    minWidth: 0,
  },
});
